import { InjectionToken } from '@angular/core';
import { Competition } from '../models/competition';
export const COMPETITION_CONFIGURATION_TOKEN = new InjectionToken<Array<Competition>>('COMPETITION_CONFIGURATION_TOKEN');
